// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-list {\n  margin-right: 20px;\n  line-height: 54px;\n}\n.task-list img {\n  width: 35px;\n}", ""]);
// Exports
module.exports = exports;
